import React, { useEffect, useState } from 'react';
import {VictoryPie } from 'victory';
import cx from "classnames"
import { InvoiceStatus } from '../../../../@types';
import { customColors, customTextColors } from '../../../invoice/Status/status';
import { EmptyInvoicePieChart } from './Empty';
interface PieData {
  value: number,
  fill: string
}

interface PieChartProps   {
  title?: string;
  isLoaded?: boolean;
  trendtitle?: string;
  trendIcon?: any;
  data: Record<string , PieData> | any;
  totalValue?: number;
  labelPosition?: string,
  innerCardWidth?: number,
  innerCardHeight?: number,
  totalName?: string,

  pieChartInnerRadius?: number,
  getStatusColor?: (status: InvoiceStatus) => string;
}
const InvoicePieChart: React.FC<PieChartProps> = ({ title, data, trendtitle,trendIcon, totalName, labelPosition, isLoaded, innerCardWidth, innerCardHeight, pieChartInnerRadius, 
 }) => {
   const [fills, setFills] = useState <any> ([])
   const [values, setValues] = useState <{x: string, y: number, fill: string}[]> ([])
   const [slices, setSlices] = useState<{ x: InvoiceStatus; y: number; fill: string }[]>([]);
  
useEffect(() => {
    const newValues = [];
    const newFills = [];
    const newSlices = [];

    for (let key in data) {
      if (data[key].fill && data[key].value) {
        const invoiceStatus = key as InvoiceStatus; 
        newValues.push({ x: invoiceStatus, y: data[key].value, fill: data[key].fill });
        newFills.push(data[key].fill);
        newSlices.push({ x: invoiceStatus, y: data[key].value, fill: data[key].fill });
      }
    }
    setValues(newValues);
    setFills(newFills);
    setSlices(newSlices);
  }, [data]);

  
   const iconStyle = {
    color: '#0D8DBF',
  };
  return (
    <>
      {!isLoaded ? (
        <p>Loading...</p>
      ) : (
        <div className={`${labelPosition == "right" ? "flex-grow py-3": "py-3 xl:py-10 xl:flex-grow 2xl:flex-grow-0" } `}>
          <div className={` ${labelPosition == "right" ? " pl-3": "flex items-center  ml-5 px-[10px] justify-between" } `}>
            <p className={`font-semibold text-[15px] md:text-[20px] xl:text-[20px] text-[#2E2E2E] leading-6 ${labelPosition == "bottom" && "" }`}>{title}</p>
            <div className="flex items-center text-[black]">
              <p className="text-[12px] font-normal leading-5">{trendtitle}</p>
              <span className="icon" style={iconStyle}> {trendIcon}
              </span>
            </div>
          </div> 
          <p className={`text-[14px] text-[#828282] pl-3 mt-[10px] ${labelPosition == "right" && "pl-3" }`}>
             {totalName}:  <b className="text-black">{title == "Transaction Type" ? data.value: values.length}</b>
          </p>

       
       <div className={`${labelPosition == "bottom" ? " flex flex-row justify-center xl:w-[330px] w-[200px] md:w-[256px] biglg:w-[300px]    " : `w-[${innerCardWidth}px] h-[${innerCardHeight}px] xl:w-[330px] w-[200px] md:w-[256px] biglg:w-[300px]      flex flex-row justify-center    `}`}>
          {values.length > 0 ? (
          <VictoryPie
           padAngle={({ datum }) => datum}
           innerRadius={pieChartInnerRadius}
           data={values}
        colorScale={Object.values(customTextColors)}
           labelComponent={<EmptyInvoicePieChart />}
              />
    ) : (
              <EmptyInvoicePieChart /> 
            )}
 
{labelPosition === "right" ? (
  <div className=' pl-[em] mr-[-5em] md:mr-[-18em]  md:mt-[3em] flex flex-col gap-[8px] items-start mt-[2em] xl:pl-[em] xl:mr-[-7em] biglg:mr-[-6em] lg:pl-[em] lg:mr-[-4em]'>
    {title === "Invoice Status" ? (
      
      values?.map((item, i) => {
        const backgroundColor = customColors[item.x as keyof typeof customColors];
        const textColor = customTextColors[item.x as keyof typeof customTextColors];
        return (
          <div className='flex flex-row gap-2 items-center justify-between mt-[-2px]' key={i}>
            <div className={cx(`flex items-center gap-[px] font-poppins px-1 rounded-md`)} style={{ backgroundColor }}>
            <p className={cx(`text-[16px] font-bold font-fellix`)} style={{ color: textColor }}>{item?.x}</p>
            </div>
              <p className='flex justify-between px-3 text-[14px]'> <span>-{item?.y} </span>  <span>%</span> </p>
          </div>
        );
      })
    ) : (
      <>
        {values.map((item, i) => {
          const backgroundColor = item.fill;
          return (
            <div className='flex flex-col gap-[20px] w-full items-center text-center justify-center'>
              <div className="flex items-center gap-[4px] font-poppins px-3 rounded-md" key={i}>
              <div className={`rounded-lg w-[8px] h-[8px] `} style={{ backgroundColor }}></div>
              
              <p className="text-[16px] font-fellix flex flex-1 gap-2 justify-between">
               <span>{item?.x}</span> <span> -{item?.y}%</span>
               </p>
            </div>
            </div>
          );
        })}
      </>
    )}
  </div>
) : (
  <>
    <hr className="flex mt-2 ml-5 px-[200px]" />
    <div className="flex gap-[40px] mt-4 font-fellix justify-center">
      <div className="flex items-center gap-[4px]">
        <div className="rounded-lg w-[8px] h-[8px] bg-[#2CD9C5]"></div>
        <p className="text-[14px]">Invoice</p>
      </div>
      <div className="flex items-center gap-[4px]">
        <div className="rounded-lg w-[8px] h-[8px] bg-[#EB5757]"></div>
        <p className="text-[14px]">Expenses</p>
      </div>
    </div>
  </>
)}

          </div>

        </div>
      )}
    </>
  );
};

export { InvoicePieChart };
